import { AxiosInstance, AxiosResponse } from 'axios';
import { TLocaleAPI } from '../types/locale';

type TPostStoreFollowingListPayload = {
    page: number;
    perPage: number;
};

export type TPostStoreFollowingListResponse = {
    data: {
        list: {
            storeCode: string;
            alias: string;
            name: string;
            url: string;
            banner: string;
            logo: string;
            isStoreActive: boolean;
            updatedAt: string;
        }[];
        pagination: {
            totalPages: number;
            page: number;
            perPage: number;
        };
    };
};

type TPostStoreFollowingCreatePayload = {
    storeCode: string;
    isActive: 0 | 1;
};

export type TStoreEndpoints = {
    postStoreFollowingList: (
        params: TPostStoreFollowingListPayload,
    ) => Promise<AxiosResponse<TPostStoreFollowingListResponse>>;
    postStoreFollowingCreate: (params: TPostStoreFollowingCreatePayload) => Promise<AxiosResponse>;
};

// #TODO: Type "object"
export default (api: AxiosInstance, apiLocale: TLocaleAPI): TStoreEndpoints => {
    const postStoreFollowingList = async (
        params?: TPostStoreFollowingListPayload,
    ): Promise<AxiosResponse<TPostStoreFollowingListResponse>> =>
        api.post<TPostStoreFollowingListResponse>(`/_svc/store/store/following/list`, params, {
            headers: { 'x-locale': apiLocale },
        });

    const postStoreFollowingCreate = async (params?: TPostStoreFollowingCreatePayload): Promise<AxiosResponse> =>
        api.post(`/_svc/store/store/following/create`, params, { headers: { 'x-locale': apiLocale } });

    return { postStoreFollowingList, postStoreFollowingCreate };
};
